var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{attrs:{"search":_vm.search,"parse":_vm.parse,"min-characters":0,"is-loading":_vm.loading,"caret":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }